@if (row(); as row) {
    <div class="flex gap-1 truncate">
        <app-product-badges [product]="row" />

        <p class="text-gray-800 ml-1">{{ row.name }}</p>
    </div>
}
